import { HTTPError } from 'ky'
import { httpClient, resolveApiUrl } from '#shared/api'
import { keycloak } from '#shared/lib/auth'
import Client from '../model/client'

export default async function getClientMe(): Promise<Client | null> {
  try {
    const response = await httpClient.get<Client>('users/client-me', {
      prefixUrl: resolveApiUrl('@sd-users'),
    })
    const parsedResponse = await response.json()
    parsedResponse.id = keycloak.tokenParsed?.sub || ''
    return parsedResponse
  } catch (error: unknown) {
    if (error instanceof HTTPError) {
      if (error.response.status === 404 || error.response.status === 403) {
        return null
      }
    }

    throw error
  }
}
